import { Box, withStyles } from 'vopay';
import { CircleButton } from 'UI';
import styles from './PasswordRules.module.scss';

const cn = withStyles(styles);

type Rule = {
  test: boolean;
  label: string;
};

type PasswordRulesProps = {
  rules: Rule[];
  title: string;
};

const PasswordRules: React.FC<PasswordRulesProps> = ({ rules, title }) => {
  const renderRule = (passed: boolean, label: string) => (
    <div key={label} className={cn('ruleContainer')}>
      <CircleButton
        icon={passed ? 'check' : 'horizontal_rule'}
        colorScheme={passed ? 'success' : 'neutral'}
        size="small"
      />
      <div className={cn(!passed && 'bold')}>{label}</div>
    </div>
  );

  return (
    <Box flx="col" gapSize="17px">
      <div className={cn('title')}>{title}</div>
      <Box flx="col" gapSize="16px">
        {rules.map((rule) => renderRule(rule.test, rule.label))}
      </Box>
    </Box>
  );
};

export default PasswordRules;
